import { Box, Button, Grid2, Typography } from "@mui/material";
import loginBackground from "./../../assets/images/loginBackground.png";
import { Formik } from "formik";
import OTP from "../../components/OTP";
import jccLogo from "./../../assets/images/jccLogo.png";
import { useState } from "react";
import { colors } from "../../values/colors";
import {
  useLazyVerifyAuctionCodeQuery,
  useVerifyAuctionCodeQuery,
} from "../../services/authenticationAPI";
import { useDispatch } from "react-redux";
import { setToken, setUser } from "../../redux/slices/user/userSlice";
import { saveToken, saveUserPref } from "../../uttils/UserPref";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const styles = {
  getOTP: {
    width: "21rem",
    height: "3rem",
    overflow: "hidden",
    borderRadius: "9px",
    borderColor: "#F7F8F9",
    textTransform: "initial",
    background:
      "var(--Grad, linear-gradient(96deg, #DA5332 -5.2%, #DA5332 -5.19%, #F78524 113.53%))",
    color: "#fff",
  },
};

const AutionAuth = () => {
  const [otp, setOtp] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [triggerVerifyAuctionCode, { isLoading }] =
    useLazyVerifyAuctionCodeQuery();
  const _verifyOTP = async () => {
    try {
      const result = await triggerVerifyAuctionCode(otp).unwrap();
      if (result?.success) {
        const token = result?.data?.accessToken;
        const refreshToken = result?.data?.refreshToken;

        localStorage.setItem("accessToken", token);
        localStorage.setItem("refreshToken", refreshToken);
        saveToken(token);
        saveUserPref(result?.data);

        dispatch(setUser(result?.data?.user));
        dispatch(setToken(token));

        navigate("/auction/auction-details");
      }
    } catch (err) {
      toast.error(err?.data?.message || "Something went wrong");
    }
  };
  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <Grid2 container direction={"row"} sx={{ width: "100%", height: "100%" }}>
        <Grid2
          size={{ xs: 12, sm: 12, md: 12, lg: 8, xl: 8 }}
          sx={{ width: "100%", height: "100%" }}
        >
          <Box
            sx={{
              height: "100%",
              backgroundImage: `url(${loginBackground})`,
              backgroundSize: "100% 100%",
            }}
          >
            <Typography
              sx={{
                position: "absolute",
                fontSize: {
                  xl: "4.5rem",
                  lg: "3.2rem",
                  md: "3.5rem",
                  sm: "2.5rem",
                  xs: "2rem",
                },
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "normal",
                color: "white",
                bottom: {
                  xl: "5rem",
                  lg: " 4.5rem",
                  md: "16rem",
                  sm: "12rem",
                  xs: "10rem",
                },
                left: {
                  xl: "5rem",
                  lg: " 6rem",
                  md: "10rem",
                  sm: "8rem",
                  xs: "4rem",
                },
              }}
            >
              Unleash the Roar,{<br />} Chase the Glory!
            </Typography>
          </Box>
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 4, xl: 4 }}>
          <Box
            sx={{
              height: "100vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                height: "219px",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box>
                <img src={jccLogo} style={{ height: "139px", width: "85px" }} />
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <Typography className={"WelcomeToJCCSprtsTitle"}>
                Match the code on your Phone
              </Typography>
              <Typography sx={{ color: colors.gray }}>
                Confirm or enter the code below to connect to this device.
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <OTP
                separator={<span></span>}
                value={otp}
                onChange={setOtp}
                length={6}
              />

              <Button
                variant={"contained"}
                onClick={_verifyOTP}
                sx={styles.getOTP}
                disabled={otp.length < 6 || isLoading}
              >
                {isLoading ? "Verifying..." : "Verify"}
              </Button>
            </Box>
          </Box>
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default AutionAuth;
